export default __webpack_public_path__ + "static/media/cp_geo_gn.ea1b6b3e.svg";